(function () {

  var allowedPaths = [
    '/',
    '/products/inglow-za-kozo-brez-aken',
    '/pages/inglow-hormonske-akne'
  ];

  if (!allowedPaths.includes(window.location.pathname)) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var container = document.createElement('div');
  container.id = 'mv-strawberries';
  document.body.appendChild(container);

  var EMOJI = '🍓';

  var BASE_SIZE = 15;
  var FALL_MIN = 1000;
  var FALL_MAX = 1500;
  var MAX_ON_SCREEN = 14;

  var lastSpawn = 0;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function spawnBerry() {

    if (container.children.length >= MAX_ON_SCREEN) return;

    var berry = document.createElement('span');

    berry.className = 'mv-strawberry';
    berry.textContent = EMOJI;

    berry.style.left = rand(2, 98) + 'vw';
    berry.style.fontSize = (BASE_SIZE + rand(-1, 1)) + 'px';
    berry.style.animationDuration = rand(FALL_MIN, FALL_MAX) + 'ms';

    container.appendChild(berry);

    setTimeout(function () {
      berry.remove();
    }, 1700);

  }

  window.addEventListener('scroll', function () {

    var now = Date.now();

    if (now - lastSpawn < 140) return;

    lastSpawn = now;

    var count = isMobile() ? 1 : 2;

    for (var i = 0; i < count; i++) {
      spawnBerry();
    }

  }, { passive: true });

})();